import axiosInstance from './interceptors'
import { VUE_APP_SERVER_BASE_URL, API_V1, TELEMETRY_API } from '../utils/constants'

export const sendFeedback = async payload => {
  await axiosInstance.post(`${VUE_APP_SERVER_BASE_URL}${API_V1}${TELEMETRY_API}/feedback`, payload)
}
